import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/close_ic.svg';
const _withScopeId = n => (_pushScopeId("data-v-02a65c9a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "planListWrapper" };
const _hoisted_2 = { class: "title" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "font-36 font-w500" }, "选择开营时间", -1));
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = { class: "list p-lr32" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "info" };
const _hoisted_10 = { class: "num font-32" };
const _hoisted_11 = { class: "time font-28 gray-9" };
const _hoisted_12 = { class: "status font-28" };
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        list: {
            type: Array,
            default: () => []
        },
        meetingId: {
            type: Number,
            default: 0
        }
    },
    emits: ['closePlan', 'selectMeeting'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const selectPlan = (item) => {
            emits('selectMeeting', item);
            closeFn();
        };
        const bl = ref(true);
        const closeFn = () => {
            if (!bl.value) {
                return;
            }
            bl.value = false;
            emits('closePlan');
            setTimeout(() => {
                bl.value = true;
            }, 330);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["planWrapper", {
                            linearUp: bl.value,
                            linearDown: !bl.value
                        }])
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        _createElementVNode("div", {
                            class: "closeBtn",
                            onClick: _withModifiers(closeFn, ["stop"])
                        }, _hoisted_6, 8, _hoisted_4)
                    ]),
                    _createElementVNode("ul", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                                class: _normalizeClass(["flexBox", {
                                        active: __props.meetingId == item.meetingId,
                                        finished: item.statusText == '已结束' || item.statusText == '名额已报满'
                                    }]),
                                onClick: _withModifiers(($event) => (selectPlan(item)), ["stop"])
                            }, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, "第" + _toDisplayString(item.schedules) + "期", 1),
                                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.meetingStartTime), 1)
                                ]),
                                _createElementVNode("div", _hoisted_12, _toDisplayString(item.statusText), 1)
                            ], 10, _hoisted_8));
                        }), 256))
                    ])
                ], 2)
            ]));
        };
    }
});
